import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import Cookies from "universal-cookie";
import uuid from "react-uuid";
import Container from "../components-layout/Container";
import Layout from "../Layout";
import { Transition } from "@headlessui/react";
import WarningModal from "../components-modals/WarningModal";
import DatagridItemsBodega from "./bodegas/DatagridItemsBodega";
import Pagination from "../components-contabilidad-analisis/Pagination";
import ResumenProductos from "./bodegas/ResumenProductos";
import { fetchApi } from "../tools";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import FacturacionForm from "./facturacion/FacturacionForm";
import SubmitButton from "./facturacion/SubmitButton";
import Pago from "./facturacion/Pago";
import { Form, Formik, useFormik } from "formik";
import { object, string, number } from "yup";
import Header from "../components-layout/Header";
import { DocumentPlusIcon } from "@heroicons/react/24/outline";
import BusquedaAlumnosModal from "./BusquedaAlumnosModal";
import { retrieveData } from "../../helpers/helpers";
import OtherWarehousesModal from "./facturacion/OtherWarehousesModal";
import FormBoletas from "../pagos-administrativo/components/FormBoletas";
import { fechaSinGuiones } from "../tools/ConversionFechas";


const searchParams = [
  "IdProducto",
  "Descripcion",
  "Descripcion_Corta",
  "Imagen",
  "IdTipo",
  "Tipo",
  "IdCategoria",
  "Categoria",
  "IdProveedor",
  "Proveedor",
  "Costo",
  "Precio",
  "Existencia",
  "Inventario",
  "FacRapida",
  "Pedido",
  "Activo",
];
let runInit = true;

const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};
const FacturacionCentro = () => {
  
  // useHandleUpdate()
  const topRef = useRef(null);
  const user = useSelector((state) => state.auth.user);
  const userObj = JSON.parse(user);

  const cookies = new Cookies();
  const urlInvoiceApi = cookies.get("__urlInvoiceApi");
  const urlSchoolApi = cookies.get("__urlSchoolApi");
  const url = urlInvoiceApi + "/utils/busquedas";
  const headers = useSelector((state) => state.url.headersAPI);

  //Fetch inicial de productos
  const [loading, setLoading] = useState(true);
  const [contado, setContado] = useState(null);
  const [rawData, setRawData] = useState([]);
  const [enableVoucher, setEnableVoucher] = useState(false);
  const [mensaje, setMensaje] = useState(false);
  const [formaPago, setFormaPago] = useState(null);
  const [formDisabled, setFormDisabled] = useState(true);
  const [monto, setMonto] = useState(0);
  const [bancos, setBancos] = useState([]);
  const [showIcon, setShowIcon] = useState(true);
  const [datosBoleta, setDatosBoleta] = useState({
    boleta: "",
    banco: "",
    fecha: "",
    saldo: "",
    valor: 0,
  });

  const [datosTransferencia, setDatosTransferencia] = useState({
    fecha: "",
    numero: "",
    banco: 0,
    valor: 0,
  });
  const [datosExtension, setDatosExtension] = useState({
    fecha: "",
    numero: "",
    valor: 0,
  });

  const bodegas = useSelector((state) => state.auth.bodegas);
  //const primerIdBodega = bodegas[0].IdBodega;
  const formik = useFormik({
    initialValues: {
      Centro: 1,
    },
  });

  const handleScrollTop = (ref) => {
    window.scrollTo({
      top: ref.offsetTop,
      left: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      //setLoading(true);
      try {
        const res = await Axios({
          method: "GET",
          url,
          headers,
          params: {
            opcion: "PRODUCTOS",
            Centro: 1,
          },
        });

        setRawData(() => res.data);
        if (res.data.length > 0) setEnableVoucher(res.data[0].Voucher);

        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);

  //Busqueda
  const [filterData, setFilter] = useState([]);
  useEffect(() => {
    setFilter(rawData);
  }, [rawData]);

  const [query, setQuery] = useState("");
  const handleQuery = (e, query) => {
    e.preventDefault();
    doSearch(query.trim());
    setCurrentPage(1);
  };

  const doSearch = (query) => {
    if (query === null) {
      setFilter(rawData);
    } else {
      setFilter(
        rawData.filter((x) => {
          return searchParams.some((y) => {
            return (
              x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        })
      );
    }
  };
  //Fin busqueda

  //Paginación Productos
  const [centro, setCentro] = useState(1);
  const [botonesDescripcion, setBotonesDescripcion] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 3;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const currentRecords = filterData?.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const nPages = Math.ceil(filterData?.length / recordsPerPage);
  //Fin paginación Productos

  //Helpers de productos tipo CRUD
  const [productos, setProducto] = useState([]);
  const [otherWarehouses, setOtherWarehouses] = useState([]);
  const [showOtherWarehousesModal, setShowOtherWarehousesModal] =
    useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState();
  const [hayEdicion, setHayEdicion] = useState(false);

  const intermediario = (flagCentro, producto) => {
    setProductoSeleccionado(producto);
    if (!flagCentro) {
      // setMensaje(() => {return false}) probar si da problemas
      setBotonesDescripcion(() => false);
      addProduct(producto);
    } else {
      setShowIcon(false);
      setBotonesDescripcion(() => true);
      setMensaje(() => {
        return false;
      });
      setModal({
        show: true,
        ok: false,
        msg: `Deseas cambiar la descripción y valor al servicio ${producto.Descripcion}?`,
      });
    }
  };

  const enviarModificado = (nuevaDescripcion, nuevoPrecio) => {
    if (!hayEdicion) {
      addProduct(productoSeleccionado);
    } else {
      let copiaSeleccionado = null;
      let productosCopia = structuredClone(currentRecords);

      let copias = productosCopia.map((e) => {
        if (
          e.IdBodega + e.IdCategoria + e.IdProducto ===
          productoSeleccionado.IdBodega +
            productoSeleccionado.IdCategoria +
            productoSeleccionado.IdProducto
        ) {
          e.Descripcion = nuevaDescripcion
            ? nuevaDescripcion
            : productoSeleccionado.Descripcion;
          e.Descripcion_Corta = nuevaDescripcion
            ? nuevaDescripcion
            : productoSeleccionado.Descripcion;
          e.Precio = nuevoPrecio
            ? parseFloat(nuevoPrecio)
            : productoSeleccionado.Precio;
          copiaSeleccionado = e;
          return e;
        }
      });
      addProduct(
        productosCopia.find(
          (e) =>
            e.IdBodega + e.IdCategoria + e.IdProducto ===
            productoSeleccionado.IdBodega +
              productoSeleccionado.IdCategoria +
              productoSeleccionado.IdProducto
        )
      );
    }
  };

  const addProduct = async (producto) => {
    // si values.Centro === 0 ? sigue el camino normal
    try {
      let {
        Existencia,
        Unidades,
        Unidad = 1,
        IdProducto,
        Inventario,
      } = producto;

      if (Existencia < 1 && Inventario) {
        const res = await retrieveData({
          url,
          headers,
          method: "GET",
          payload: {
            opcion: "PRODUCTOSGRAL",
            IdProducto,
          },
        });

        const otherWarehousesWithProductArr = res;
        if (otherWarehousesWithProductArr.length === 0) {
          setMensaje(() => {
            return true;
          });
          throw new Error("Sin existencias en todas las bodegas");
        }

        setOtherWarehouses(otherWarehousesWithProductArr);
        return setShowOtherWarehousesModal(true);
      }

      if (Unidades) {
        Unidad = Unidades[0].Unidad;
      }

      const isDuplicated =
        productos.findIndex(
          (prod) => prod.IdProducto === producto.IdProducto
        ) !== -1
          ? true
          : false;

      if (!isDuplicated) {
        const id = uuid();

        setProducto((curr) => [...curr, { ...producto, id, qty: 1, Unidad }]);
      }
    } catch (err) {
      console.log(err);
      setMensaje(() => {
        return true;
      }); // para que no muestre los botones no sí
      setShowIcon(() => true);
      return setModal({
        msg: "Producto sin existencias",
        ok: false,
        show: true,
      });
    }
  };

  const updateProducto = (producto, prop = "", payload = "") => {
    const { id, Existencia } = producto;
    const indexOfId = productos.findIndex((producto) => producto.id === id);

    if (prop === "qty" || prop === "Unidad") {
      return setProducto((curr) => {
        if (centro && payload >= 1) {
          curr[indexOfId][prop] = payload;
        } else {
          if (payload >= 1 && payload <= Existencia) {
            curr[indexOfId][prop] = payload;
          }
        }
        return [...curr];
      });
    }

    if (prop === "Descripcion" || prop === "Precio") {
      return setProducto((curr) => {
        curr[indexOfId][prop] = payload;
        return [...curr];
      });
    }
  };

  const delProducto = (producto) => {
    const { id } = producto;

    const newProductos = productos.filter((prod) => prod.id !== id);
    setProducto(newProductos);
  };

  //Manejo de errores
  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });

  //Formateo de values y POST

  const fetchData = async (data) => {
    setMensaje(() => {
      return true;
    });
    setLoading(true);
    try {
      const res = await Axios({
        method: "POST",
        url: urlInvoiceApi + "/inventario/facturas",
        headers,
        data,
      });

      const { Error: err, Mensaje } = res.data.msg;

      if (err !== 0) {
        throw new Error(Mensaje);
      }

      setLoading(false);
      setMensaje(() => {
        return true;
      });
      setShowIcon(() => true);
      setModal({
        msg: "¡Transacción realizada con exito!",
        ok: true,
        show: true,
        reload: true,
      });
    } catch (err) {
      setLoading(false);
      const msg = err.response.data.msg.Mensaje;
      setShowIcon(() => true);
      setModal({
        ok: false,
        msg: msg,
        show: true,
        reload: true,
      });
      console.log(err);
    }
  };

  const IdEmp = useSelector((state) => state.auth.IdEmp);

  const handleSubmit = (values) => {
    handleScrollTop(topRef.current);
    setBotonesDescripcion(() => false);
    const validacionCel = /\d{7}/.test(values.Cel);

    const d = new Date().toLocaleDateString("es-GT");
    const fecha = d
      .split("/")
      .reverse()
      .map((x) => x.padStart(2, "0"))
      .join("");

    let {
      mmyy,
      efectivo,
      tarjeta,
      noBoleta,
      fechaBoleta,
      monto,
      Nit,
      Direccion,
      ...resto
    } = values;
    let voucher = enableVoucher ? values.voucher : null;
    let [mes, year] = mmyy.split("/");
    year = year ? "20" + year : "";

    //IdBodega = IdBodega === '' ? primerIdBodega : IdBodega;
    //Revisar que el movimiento de bodega no este vacio
    if (productos.length === 0) {
      setMensaje(() => {
        return true;
      });
      setShowIcon(() => true);
      return setModal({
        msg: "Seleccione al menos un producto",
        ok: false,
        show: true,
      });
    }

    //Revisar si todos los productos llevan cantidad valida
    if (productos.some((producto) => producto.qty === 0)) {
      setMensaje(() => {
        return true;
      });
      setShowIcon(() => true);
      return setModal({
        msg: "Ingrese la cantidad en todos los productos",
        ok: false,
        show: true,
      });
    }

    if (monto >= 2500 && Nit === "CF") {
      setMensaje(() => {
        return true;
      });
      setShowIcon(() => true);
      return setModal({
        msg: "Para montos mayores a Q2500.00 no se puede facturar con CF.",
        ok: false,
        show: true,
      });
    }

    //Revisar subtotal
    const subtotal = enableVoucher
      ? Number(efectivo) + Number(tarjeta) + Number(voucher)
      : Number(efectivo) + Number(tarjeta);

    if (contado !== 0) {
      if (monto !== subtotal) {
        setMensaje(() => {
          return true;
        });
        setShowIcon(() => true);
        return setModal({
          msg: "Revisar formas de pago. Subtotal no coincide con total.",
          ok: false,
          show: true,
        });
      }
    }

    //Formateo de formas de pago
    const FormasPago = fomatearFormasPago(
      efectivo,
      tarjeta,
      fecha,
      voucher,
      noBoleta,
      fechaBoleta,
      datosBoleta,
      datosTransferencia
    );

    //Formateo de productos seleccionados
    const DetalleProductos = productos.map(
      ({
        IdBodega,
        IdProducto,
        qty,
        Unidad,
        Descripcion,
        Precio,
        Consignacion,
      }) => ({
        Descripcion,
        Precio,
        Consignacion: Consignacion ? 1 : 0,
        IdProducto,
        IdBodega: !IdBodega ? values.IdBodega : IdBodega,
        Cantidad: qty,
        Unidad,
      })
    );

    const data = JSON.stringify({
      ...resto,
      Nit,
      Direccion: Direccion.length > 200 ? Direccion.slice(0, 200) : Direccion,
      monto,
      mes,
      year,
      Canal: 4,
      FormasPago,
      Contado: contado,
      DetalleProductos,
      IdEmp,
      HostName: "DEV07",
      IpHost: "131.107.1.235",
      OS: "Windows",
    });

    fetchData(data);
  };

  const buscarBoleta = async () => {
    try {
      const res = await fetchApi({
        url: urlInvoiceApi + "/utils/valida_boleta",
        headers,
        content: {
          Numero: datosBoleta.boleta.toString(),
          IdBanco: datosBoleta.banco.toString(),
          FechaBoleta: fechaSinGuiones(datosBoleta.fecha),
        },
      });

      setDatosBoleta({
        ...datosBoleta,
        saldo: res[0][0].SaldoBoleta,
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleFormChange = (e) => {
    setDatosBoleta({
      ...datosBoleta,
      [e.target.name]: e.target.value,
    });
  };

  const habilitarFormBoleta = () => {
    setFormDisabled(false);
  };

  const textoPago = (formaPagoParam) => {
    const opciones = {
      1: "transferencia",
      2: "tarjeta",
      3: "boleta",
    };
    return opciones[formaPagoParam] || "";
  };

  const getBancos = async () => {
    const resBancos = await fetchApi({
      url: urlSchoolApi + "/utils/busquedas",
      headers,
      content: { opcion: "BANCOS" },
    });
    setBancos(() => resBancos);
  };

  useEffect(() => {
    if (contado === 0) {
      setFormaPago(null);
    }
  }, [contado]);

  useEffect(() => {
    function handleScroll(event) {
      if (document.activeElement.type === "number") {
        event.target.blur();
      }
    }

    window.addEventListener("wheel", handleScroll);
    return () => {
      window.removeEventListener("wheel", handleScroll);
    };
  }, []);

  const [botonBolqueado, setBotonBloqueado] = useState(false);

  useEffect(() => {
    if (
      formaPago === 3 &&
      datosBoleta.boleta !== "" &&
      datosBoleta.banco !== 0 &&
      datosBoleta.fecha !== "" &&
      datosBoleta.saldo
    ) {
      setBotonBloqueado(false);
    } else {
      if (datosBoleta.saldo > 0) {
        if (
          datosBoleta.saldo <
          productos.reduce((prev, next) => prev + next?.Precio * next?.qty, 0)
        ) {
          setBotonBloqueado(true);
          setShowIcon(true);
          setModal({
            ok: false,
            show: true,
            msg: "El saldo de la boleta es insuficiente para el pago de la factura",
          });
        } else {
          setBotonBloqueado(false);
          // habilitar el botón
        }
        // deshabilitar el botón
      }
    }
  }, [datosBoleta]);

  useEffect(() => {
    setFormaPago(() => null);
  }, [contado]);

  useEffect(() => {
    setMonto(productos.reduce((prev, next) => prev + next.Precio, 0));
  }, [productos]);

  useEffect(() => {
    if (formaPago === 1) {
      getBancos();
    }
  }, [formaPago]);

  
  //Estado que maneja componente de busqueda de alumno (modal)
  const [showSearchModal, setShowSearchModal] = useState(false);

  return (
    <Layout userObj={userObj} activeTab="Facturación">
      <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />

      <WarningModal
        //showIcon={showIcon}
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon
              className={`h-20 w-20 text-yellow-500 mx-auto`}
            />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        {centro && !botonesDescripcion && (
          <div className="mt-5 sm:mt-6 flex flex-row gap-2">
            <button
              onClick={() => {
                setShowIcon(() => true);
                setModal((curr) => ({
                  ...curr,
                  show: false,
                }));
              }}
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-azulBrillanteMira bg-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-azulBrillanteMira transition duration-500 ease focus:outline-none sm:text-sm"
            >
              No
            </button>

            <button
              onClick={() => {
                setShowIcon(() => true);
                setModal((curr) => ({
                  ...curr,
                  show: false,
                }));
              }}
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
            >
              Sí
            </button>
          </div>
        )}
      </WarningModal>
      <Transition ref={topRef} show={true}>
        <OtherWarehousesModal
          setShowForm={setShowOtherWarehousesModal}
          showForm={showOtherWarehousesModal}
          data={otherWarehouses}
          url={urlInvoiceApi}
          headers={headers}
          addProduct={addProduct}
        />

        <Container height="h-full">
          <Formik
            initialValues={{
              //Campos de la factura
              //Centro: 1,
              Carnet: "",
              Alumno: "",
              IdBodega: 0,
              Nit: "",
              NombreDoc: "",
              Centro: 1,
              Direccion: "",
              Cel: "",
              Email: "",
              //Campos solo necesarios si se cancela con tarjeta de crédito
              number: "",
              mmyy: "",
              code: "",
              nombres: "",
              apellidos: "",
              direccion: "",
              pais: "",
              email: "",
              //Campos solo necesarios si se cancela con voucher
              noBoleta: "",
              fechaBoleta: "",
              //Campo requeridos para realizar pago
              monto: "",
              efectivo: 0,
              tarjeta: 0,
              voucher: 0,
            }}
            validationSchema={object({
              Nit: string().required("Dato obligatorio."),
              NombreDoc: string().when("Nit", {
                is: "CF",
                then: (schema) => schema,
                otherwise: (schema) => schema.required("Dato obligatorio"),
              }),

              Cel:
                centro !== 1
                  ? string().required("Dato obligatorio.")
                  : string(),
              Email:
                centro !== 1
                  ? string().required("Dato obligatorio.")
                  : string(),
              Direccion:
                centro !== 1
                  ? string().required("Dato obligatorio.")
                  : string(),

              efectivo: number().required("Dato obligatorio."),
              tarjeta: number().required("Dato obligatorio."),
            })}
            onSubmit={(values) => eventManager(handleSubmit(values))}
          >
            {({ values, setFieldValue, resetForm, errors, touched }) => {
              return (
                <Form>
                  <BusquedaAlumnosModal
                    setShowForm={setShowSearchModal}
                    showForm={showSearchModal}
                    url={url}
                    headers={headers}
                    setModal={setModal}
                    setFieldValue={setFieldValue}
                    values={values}
                  />
                  <Header
                    title="Generar factura centro"
                    logo={DocumentPlusIcon}
                  />
                  <div className="flex w-full flex-col">
                    <div className="flex flex-row w-full gap-1">
                      <div className="flex w-1/3 bg-primarioMira rounded-md">
                        <div className="/mx-auto /p-2 w-full">
                          <FacturacionForm
                            col={true}
                            showIcon={showIcon}
                            hayEdicion={hayEdicion}
                            setHayEdicion={setHayEdicion}
                            url={urlInvoiceApi}
                            url2={url}
                            centro={1}
                            setCentro={setCentro}
                            headers={headers}
                            setModal={setModal}
                            values={values}
                            setFieldValue={setFieldValue}
                            resetForm={resetForm}
                            setRawData={setRawData}
                            setEnableVoucher={setEnableVoucher}
                            setLoading={setLoading}
                            setShowSearchModal={setShowSearchModal}
                            modal={modal}
                            //primerIdBodega={primerIdBodega}
                            productoSeleccionado={productoSeleccionado}
                            botonesDescripcion={botonesDescripcion}
                            setBotonesDescripcion={setBotonesDescripcion}
                            enviarModificado={enviarModificado}
                            setMensaje={setMensaje}
                            mensaje={mensaje}
                            setProducto={setProducto}
                          />
                        </div>
                      </div>
                      <div
                        className={
                          "w-2/3 flex-col bg-primarioMira rounded-md /p-2"
                        }
                      >
                        <DatagridItemsBodega
                          col={true}
                          centro={centro}
                          data={currentRecords}
                          handleQuery={handleQuery}
                          addProduct={intermediario}
                          values={values}
                          isFormik={false}
                          query={query}
                          setQuery={setQuery}
                          label="Lista detallada de servicios donde puede consultar y agregar servicios a la factura."
                        />
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          totalRecords={filterData?.length}
                          indexOfFirstRecord={indexOfFirstRecord}
                          indexOfLastRecord={indexOfLastRecord}
                        />
                      </div>
                    </div>

                    <div className="flex flex-row w-full gap-1 mt-1">
                      <div
                        className={classNames(
                          typeof contado === "number" ? "w-2/4" : "w-3/4",
                          "flex bg-primarioMira rounded-md"
                        )}
                      >
                        <ResumenProductos
                          centro={1}
                          full={true}
                          productos={productos}
                          delProducto={delProducto}
                          updateProducto={updateProducto}
                          height={"2xl:h-[15rem]"}
                        />
                      </div>
                      <div
                        className={classNames(
                          typeof contado === "number" ? "w-2/4" : "w-1/4",
                          "flex flex-col bg-primarioMira rounded-md"
                        )}
                      >
                        <div className={"p-6 flex flex-col -mb-8"}>
                          <div className="flex flex-col w-1/2">
                            <h3 className="text-lg font-medium leading-6 text-white">{`Tipo de pago ${textoPago(
                              formaPago
                            )}`}</h3>
                            <p className="py-2 text-sm text-grisMira">
                              Seleccione el tipo de pago.
                            </p>
                          </div>

                          <div className="flex flex-row w-full justify-between ">
                            <div className="flex flex-row gap-2 text-white justify-end">
                              <h1>Al contado</h1>
                              <input
                                type="radio"
                                className="my-auto"
                                checked={contado === 1}
                                onChange={() => setContado(() => 1)}
                              ></input>
                            </div>
                            <div className="flex flex-row gap-2 text-white justify-end">
                              <h1>Al crédito</h1>
                              <input
                                type="radio"
                                className="my-auto"
                                checked={contado === 0}
                                onChange={() => setContado(() => 0)}
                              ></input>
                            </div>
                          </div>
                        </div>

                        {typeof contado === "number" ? (
                          contado === 1 ? (
                            <>
                              <div className="flex flex-row w-full justify-between p-6">
                                <div className="flex flex-row gap-2 text-white justify-end">
                                  <h1>Transferencia</h1>
                                  <input
                                    type="radio"
                                    className="my-auto"
                                    checked={formaPago === 1}
                                    onChange={() => setFormaPago(1)}
                                  ></input>
                                </div>
                                <div className="flex flex-row gap-2 text-white justify-end">
                                  <h1>Tarjeta</h1>
                                  <input
                                    type="radio"
                                    className="my-auto"
                                    checked={formaPago === 2}
                                    onChange={() => setFormaPago(2)}
                                  ></input>
                                </div>
                                <div className="flex flex-row gap-2 text-white justify-end">
                                  <h1>Boleta</h1>
                                  <input
                                    type="radio"
                                    className="my-auto"
                                    checked={formaPago === 3}
                                    onChange={() => setFormaPago(3)}
                                  ></input>
                                </div>
                                {true ? null : (
                                  <div className="flex flex-row gap-2 text-white justify-end">
                                    <h1>Extensión de IVA</h1>
                                    <input
                                      type="radio"
                                      className="my-auto"
                                      checked={formaPago === 9}
                                      onChange={() => setFormaPago(9)}
                                    ></input>
                                  </div>
                                )}
                              </div>

                              <div className="flex flex-col h-full">
                                {formaPago === 1 ? (
                                  <div className="p-4 flex flex-row justify-between gap-2">
                                    <div className="flex flex-col w-1/2">
                                      <label
                                        htmlFor="numero"
                                        className="text-white"
                                      >
                                        Número de transferencia
                                      </label>
                                      <input
                                        name="numero"
                                        type="text"
                                        className="rounded-md"
                                        onChange={(e) =>
                                          setDatosTransferencia({
                                            ...datosTransferencia,
                                            [e.target.name]: e.target.value,
                                          })
                                        }
                                      ></input>
                                    </div>

                                    <div className={"flex flex-col"}>
                                      <label className="text-white">
                                        Banco
                                      </label>
                                      <select
                                        name="banco"
                                        type="select"
                                        //disabled={formDisabled}
                                        onChange={(e) =>
                                          setDatosTransferencia({
                                            ...datosTransferencia,
                                            banco: e.target.value,
                                          })
                                        }
                                        className={
                                          "rounded-md w-full text-black basis-1/4 m-auto"
                                        }
                                      >
                                        <option value="">
                                          {"---Selecciona el Banco---"}
                                        </option>
                                        {bancos.map((data) => (
                                          <option
                                            key={data.IdBanco}
                                            value={data.IdBanco}
                                          >
                                            {data.Nombre}
                                          </option>
                                        ))}
                                      </select>
                                    </div>

                                    <div className="flex flex-col w-1/2">
                                      <label
                                        htmlFor="fecha"
                                        className="text-white"
                                      >
                                        Fecha
                                      </label>
                                      <input
                                        min="1900-01-01"
                                        max="2099-01-01"
                                        name="fecha"
                                        type="date"
                                        className="rounded-md"
                                        onChange={(e) =>
                                          setDatosTransferencia({
                                            ...datosTransferencia,
                                            [e.target.name]: e.target.value,
                                          })
                                        }
                                      ></input>
                                    </div>
                                  </div>
                                ) : null}

                                {formaPago === 2 ? <></> : null}
                                {formaPago === 3 ? (
                                  <div className="p-6">
                                    <FormBoletas
                                      centro={1}
                                      url={urlSchoolApi}
                                      headers={headers}
                                      setData={setDatosBoleta}
                                      buscarBoleta={buscarBoleta}
                                      handleFormChange={handleFormChange}
                                      datosBoleta={datosBoleta}
                                      formDisabled={formDisabled}
                                      saldo={datosBoleta.saldo}
                                      habilitarFormBoleta={habilitarFormBoleta}
                                    />
                                  </div>
                                ) : null}
                                {formaPago === 99 ? (
                                  <div className="p-4 flex flex-row justify-between gap-2">
                                    <div className="flex flex-col w-1/3">
                                      <label
                                        htmlFor="numero"
                                        className="text-white"
                                      >
                                        Número de extensión
                                      </label>
                                      <input
                                        name="numero"
                                        type="text"
                                        className="rounded-md"
                                        onChange={(e) =>
                                          setDatosExtension({
                                            ...datosExtension,
                                            [e.target.name]: e.target.value,
                                          })
                                        }
                                      ></input>
                                    </div>
                                    <div className="flex flex-col w-1/3">
                                      <label
                                        htmlFor="fecha"
                                        className="text-white"
                                      >
                                        Fecha
                                      </label>
                                      <input
                                        name="fecha"
                                        type="date"
                                        className="rounded-md"
                                        onChange={(e) =>
                                          setDatosExtension({
                                            ...datosExtension,
                                            [e.target.name]: e.target.value,
                                          })
                                        }
                                      ></input>
                                    </div>
                                  </div>
                                ) : null}
                                {formaPago !== null && (
                                  <Pago
                                    col={true}
                                    //monto={monto}
                                    mensaje={mensaje}
                                    formaPago={formaPago} // prueba para desaparecer los controles de adentro del pago
                                    contado={contado}
                                    setContado={setContado}
                                    setMensaje={setMensaje}
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    productos={productos}
                                    setModal={setModal}
                                    errors={errors}
                                    touched={touched}
                                    enableVoucher={enableVoucher}
                                    centro={centro}
                                    botonesDescripcion={botonesDescripcion}
                                  />
                                )}

                                <div className="flex flex-col h-[100%] ">
                                  {[1, 2, 3].includes(formaPago) ? null : (
                                    <div className="flex flex-row justify-between h-1/2 "></div>
                                  )}
                                  {formaPago === 3 &&
                                  datosBoleta.saldo <= 0 ? null : (
                                    <div className="flex flex-row h-1/2 justify-end">
                                      <div className="p-6 mt-6 my-auto /flex ">
                                        <SubmitButton
                                          label={"Realizar factura"}
                                          className="mx-auto inline py-0"
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="flex flex-col h-[100%] justify-end">
                              <>
                                <Pago
                                  col={true}
                                  formaPago={formaPago} // prueba para desaparecer los controles de adentro del pago
                                  contado={contado}
                                  setContado={setContado}
                                  setMensaje={setMensaje}
                                  values={values}
                                  setFieldValue={setFieldValue}
                                  productos={productos}
                                  setModal={setModal}
                                  errors={errors}
                                  touched={touched}
                                  enableVoucher={enableVoucher}
                                  centro={centro}
                                  botonesDescripcion={botonesDescripcion}
                                />
                              </>
                              <div className="flex flex-row h-1/2 justify-end "></div>
                              <div className="flex flex-row h-1/2 justify-end ">
                                <div className="p-6 mt-12 my-auto flex flex-end ">
                                  <SubmitButton
                                    label={"Realizar factura"}
                                    className="mx-auto inline py-0"
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        ) : null}
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Container>
      </Transition>
    </Layout>
  );
};

const fomatearFormasPago = (
  efectivo,
  tarjeta,
  fecha,
  voucher,
  noBoleta,
  fechaBoleta,
  datosBoleta,
  datosTransferencia
) => {
  let array = [];

  array[0] = {
    TipoTrans: 1, //efectivo
    NoBoleta: "",
    IdBanco: 0,
    Valor: 0,
    Fecha: fecha,
  };

  array[1] = {
    TipoTrans: 3, // Boleta
    NoBoleta: datosBoleta.boleta,
    IdBanco: datosBoleta.banco ? parseInt(datosBoleta.banco) : 0,
    Valor: datosBoleta.boleta ? parseFloat(efectivo) : 0,
    Fecha: datosBoleta.fecha ? fechaSinGuiones(datosBoleta.fecha) : fecha,
  };

  array[2] = {
    TipoTrans: 8, // TC
    NoBoleta: "",
    IdBanco: 0,
    Valor: parseFloat(tarjeta),
    Fecha: fecha,
  };

  array[3] = {
    TipoTrans: 9, // Transferencia
    NoBoleta: datosTransferencia.numero
      ? datosTransferencia.numero.toString()
      : "",
    IdBanco: datosTransferencia.banco ? parseInt(datosTransferencia.banco) : 0,
    Valor: datosTransferencia.banco ? parseFloat(efectivo) : 0,
    Fecha: datosTransferencia.numero
      ? fechaSinGuiones(datosTransferencia.fecha)
      : fecha,
  };

  if (voucher) {
    array[2] = {
      TipoTrans: 4,
      NoBoleta: noBoleta,
      IdBanco: 0,
      Valor: voucher,
      Fecha: fechaBoleta,
    };
  }

  return array;
};

export default FacturacionCentro;

function eventManager(fn) {
  let excecuting = false;
  return async () => {
    if (!excecuting) {
      excecuting = true;
      console.log("ejecutando... ", excecuting);
      await fn();
      setTimeout(() => {
        excecuting = false;
      }, 15000);
    }
  };
}
